import { FeatureManagementRoute } from '@/features/feature-management/navigation/featureManagementRoute';
import { FeatureSettingScreen } from '@/features/feature-management/screens/FeatureSettingScreen';
import { NavigationBar } from '@/navigation/components/navbar/NavigationBar';
import { AppStack } from '@/navigation/stacks/appStack';
import { NavBarType } from '@/navigation/types/navbar';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

export const useFeatureManagementRouting = () => {
  const { colors } = useAppTheme();

  return {
    featureManagementScreens: __DEV__
      ? [
          <AppStack.Screen
            key={FeatureManagementRoute.FeatureSettings}
            name={FeatureManagementRoute.FeatureSettings}
            component={FeatureSettingScreen}
            options={{
              header: () => (
                <NavigationBar
                  title={'Features'}
                  type={NavBarType.DEFAULT}
                  centerTitle
                  backgroundColor={colors.primary}
                  iconColor={colors.onPrimary}
                  titleColor={colors.onPrimary}
                />
              ),
              headerShown: true,
              presentation: 'containedModal',
              animation: 'fade'
            }}
          />
        ]
      : []
  };
};
